<template>
  <div class="uk-container">
    <div class="uk-width-xxlarge uk-margin-auto uk-card uk-card-default">
      <table-enquiry />
    </div>
  </div>
</template>

<script>
import TableEnquiry from '@/components/table/Enquiry.vue'

export default {
  name: 'ViewEnquiryList',

  components: { TableEnquiry }
}
</script>
